import { NavLink } from 'react-router-dom'
import { Building2, Gauge, Users } from 'lucide-react'

const items = [
  { to: '/organizations', label: 'ארגונים', icon: Building2 },
  { to: '/users', label: 'משתמשים', icon: Users },
  { to: '/monitor', label: 'מוניטור', icon: Gauge },
]

export default function OpsMobileNav() {
  return (
    <nav
      aria-label="Otomator Ops"
      className="grid grid-cols-3 gap-1 rounded-xl p-1 lg:hidden"
      style={{ background: '#1a1d27', border: '1px solid #2d3148' }}
    >
      {items.map(({ to, label, icon: Icon }) => (
        <NavLink
          key={to}
          to={to}
          className={({ isActive }) =>
            `flex min-h-10 items-center justify-center gap-1.5 rounded-lg px-2 text-xs font-medium transition-colors ${
              isActive ? 'text-indigo-200' : 'text-gray-400'
            }`
          }
          style={({ isActive }) => ({ background: isActive ? '#6366f125' : 'transparent' })}
        >
          <Icon size={15} />
          {label}
        </NavLink>
      ))}
    </nav>
  )
}
